export const ApplyNewIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    fill="none"
    viewBox="0 0 24 24"
    stroke="white"
    strokeWidth="2"
  >
    <path
      d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15"
      strokeLinecap="round"
    />
    <path
      d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
      strokeLinecap="round"
    />
  </svg>
);

export const AppliedIcon = () => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.78568 14.3033C4.78568 13.3324 5.17136 12.4013 5.85788 11.7148C6.54439 11.0283 7.47551 10.6426 8.44639 10.6426C9.41728 10.6426 10.3484 11.0283 11.0349 11.7148C11.7214 12.4013 12.1071 13.3324 12.1071 14.3033C12.1071 15.2742 11.7214 16.2053 11.0349 16.8918C10.3484 17.5783 9.41728 17.964 8.44639 17.964C7.47551 17.964 6.54439 17.5783 5.85788 16.8918C5.17136 16.2053 4.78568 15.2742 4.78568 14.3033ZM8.44639 12.839C8.05804 12.839 7.68559 12.9933 7.41099 13.2679C7.13638 13.5425 6.98211 13.9149 6.98211 14.3033C6.98211 14.6916 7.13638 15.0641 7.41099 15.3387C7.68559 15.6133 8.05804 15.7676 8.44639 15.7676C8.83475 15.7676 9.20719 15.6133 9.4818 15.3387C9.75641 15.0641 9.91068 14.6916 9.91068 14.3033C9.91068 13.9149 9.75641 13.5425 9.4818 13.2679C9.20719 12.9933 8.83475 12.839 8.44639 12.839ZM8.44639 20.8926C7.47551 20.8926 6.54439 21.2783 5.85788 21.9648C5.17136 22.6513 4.78568 23.5824 4.78568 24.5533C4.78568 25.5242 5.17136 26.4553 5.85788 27.1418C6.54439 27.8283 7.47551 28.214 8.44639 28.214C9.41728 28.214 10.3484 27.8283 11.0349 27.1418C11.7214 26.4553 12.1071 25.5242 12.1071 24.5533C12.1071 23.5824 11.7214 22.6513 11.0349 21.9648C10.3484 21.2783 9.41728 20.8926 8.44639 20.8926ZM6.98211 24.5533C6.98211 24.1649 7.13638 23.7925 7.41099 23.5179C7.68559 23.2433 8.05804 23.089 8.44639 23.089C8.83475 23.089 9.20719 23.2433 9.4818 23.5179C9.75641 23.7925 9.91068 24.1649 9.91068 24.5533C9.91068 24.9416 9.75641 25.3141 9.4818 25.5887C9.20719 25.8633 8.83475 26.0176 8.44639 26.0176C8.05804 26.0176 7.68559 25.8633 7.41099 25.5887C7.13638 25.3141 6.98211 24.9416 6.98211 24.5533ZM15.0357 13.9372C15.0357 13.646 15.1514 13.3666 15.3573 13.1607C15.5633 12.9547 15.8426 12.839 16.1339 12.839H27.116C27.4073 12.839 27.6866 12.9547 27.8926 13.1607C28.0985 13.3666 28.2143 13.646 28.2143 13.9372C28.2143 14.2285 28.0985 14.5078 27.8926 14.7138C27.6866 14.9197 27.4073 15.0354 27.116 15.0354H16.1339C15.8426 15.0354 15.5633 14.9197 15.3573 14.7138C15.1514 14.5078 15.0357 14.2285 15.0357 13.9372ZM16.1339 23.089C15.8426 23.089 15.5633 23.2047 15.3573 23.4107C15.1514 23.6166 15.0357 23.896 15.0357 24.1872C15.0357 24.4785 15.1514 24.7578 15.3573 24.9638C15.5633 25.1697 15.8426 25.2854 16.1339 25.2854H27.116C27.4073 25.2854 27.6866 25.1697 27.8926 24.9638C28.0985 24.7578 28.2143 24.4785 28.2143 24.1872C28.2143 23.896 28.0985 23.6166 27.8926 23.4107C27.6866 23.2047 27.4073 23.089 27.116 23.089H16.1339ZM4.78568 6.61579C4.78568 6.32453 4.90138 6.04519 5.10734 5.83924C5.31329 5.63328 5.59263 5.51758 5.88389 5.51758H27.116C27.4073 5.51758 27.6866 5.63328 27.8926 5.83924C28.0985 6.04519 28.2143 6.32453 28.2143 6.61579C28.2143 6.90706 28.0985 7.18639 27.8926 7.39235C27.6866 7.5983 27.4073 7.71401 27.116 7.71401H5.88389C5.59263 7.71401 5.31329 7.5983 5.10734 7.39235C4.90138 7.18639 4.78568 6.90706 4.78568 6.61579ZM5.88389 0.392578C4.42757 0.392578 3.0309 0.9711 2.00112 2.00088C0.971344 3.03065 0.392822 4.42733 0.392822 5.88365V27.1158C0.392822 28.5721 0.971344 29.9688 2.00112 30.9986C3.0309 32.0283 4.42757 32.6069 5.88389 32.6069H27.116C28.5724 32.6069 29.969 32.0283 30.9988 30.9986C32.0286 29.9688 32.6071 28.5721 32.6071 27.1158V5.88365C32.6071 4.42733 32.0286 3.03065 30.9988 2.00088C29.969 0.9711 28.5724 0.392578 27.116 0.392578H5.88389ZM2.58925 5.88365C2.58925 5.00986 2.93636 4.17185 3.55423 3.55399C4.1721 2.93612 5.0101 2.58901 5.88389 2.58901H27.116C27.9898 2.58901 28.8278 2.93612 29.4457 3.55399C30.0636 4.17185 30.4107 5.00986 30.4107 5.88365V27.1158C30.4107 27.9896 30.0636 28.8276 29.4457 29.4455C28.8278 30.0633 27.9898 30.4104 27.116 30.4104H5.88389C5.0101 30.4104 4.1721 30.0633 3.55423 29.4455C2.93636 28.8276 2.58925 27.9896 2.58925 27.1158V5.88365Z"
      fill="white"
    />
  </svg>
);

export const PendingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-7 h-7"
    viewBox="0 0 1024 1024"
    fill="#ff9800"
  >
    <path d="M511.9 183c-181.8 0-329.1 147.4-329.1 329.1s147.4 329.1 329.1 329.1c181.8 0 329.1-147.4 329.1-329.1S693.6 183 511.9 183z m0 585.2c-141.2 0-256-114.8-256-256s114.8-256 256-256 256 114.8 256 256-114.9 256-256 256z" />
    <path d="M548.6 365.7h-73.2v161.4l120.5 120.5 51.7-51.7-99-99z" />
  </svg>
);

export const IssuedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-7 h-7"
    fill="none"
    viewBox="0 0 16 16"
    stroke="#4caf50"
    strokeWidth="1"
  >
    <path d="M14 10.58c0.024-0.048 0.038-0.105 0.038-0.165s-0.014-0.117-0.039-0.167l-0.479-0.698c-0.009-0.013-0.014-0.028-0.014-0.045s0.005-0.032 0.014-0.045l0.48-0.7c0.024-0.048 0.038-0.105 0.038-0.165s-0.014-0.117-0.039-0.167c-0.040-0.11-0.127-0.196-0.236-0.237l-0.823-0.301c-0.031-0.011-0.054-0.037-0.060-0.069l-0-0.841c-0.007-0.125-0.072-0.233-0.169-0.299-0.066-0.045-0.145-0.071-0.231-0.071l-1.009 0-0.55-0.65c-0.079-0.085-0.191-0.137-0.315-0.137s-0.236 0.053-0.315 0.137l-0.55 0.65-0.9-0.23h-0.1c-0.087 0-0.167 0.026-0.234 0.071-0.096 0.066-0.161 0.174-0.168 0.298v0.841l-0.821 0.3c-0.134 0.023-0.245 0.11-0.299 0.228-0.025 0.051-0.039 0.107-0.039 0.167s0.014 0.117 0.039 0.167l0.479 0.698c0.009 0.013 0.014 0.028 0.014 0.045s-0.005 0.032-0.014 0.045l-0.48 0.7c-0.024 0.048-0.038 0.105-0.038 0.165s0.014 0.117 0.039 0.167c0.040 0.11 0.127 0.196 0.236 0.237l0.823 0.301c0.031 0.011 0.054 0.037 0.060 0.069l0 0.841c0.007 0.125 0.072 0.233 0.169 0.299 0.067 0.045 0.147 0.071 0.234 0.071h0.16l0.31-0.070v3.69l1.53-2 1.47 2v-3.69l0.31 0.080h0.11c0.087 0 0.167-0.026 0.234-0.071 0.096-0.066 0.161-0.174 0.168-0.298l0-0.841 0.821-0.3c0.13-0.026 0.236-0.112 0.289-0.227z" />
    <path d="M0 1v12h8l-0.11-0.050c-0.282-0.195-0.469-0.508-0.49-0.867h-6.4v-10h14v10h-1.43c-0.021 0.361-0.208 0.675-0.486 0.868h3v-12h-16z" />
    <path d="M7.43 6.91c0.007-0.377 0.198-0.708 0.486-0.908 0.016-0.005 0.030-0.006 0.044-0.006s0.028 0.001 0.041 0.004h-5.001v1h4.43v-0.090z" />
    <path d="M6.42 8h-3.42v1h3.36c-0.074-0.136-0.117-0.298-0.117-0.47 0-0.13 0.025-0.253 0.070-0.367 0.014-0.063 0.054-0.122 0.107-0.163z" />
    <path d="M3 4h10v1h-10v-1z" />
  </svg>
);

export const RejectedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-7 h-7"
    fill="none"
    viewBox="0 0 24 24"
    stroke="#f44336"
    strokeWidth="2"
  >
    <line
      x1="10.5"
      y1="10.5"
      x2="13.5"
      y2="13.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="13.5"
      y1="10.5"
      x2="10.5"
      y2="13.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17,3H6A1,1,0,0,0,5,4V20a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V5H17Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DraftIcon = () => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.436 17.0898H28.5767C28.4306 17.0898 28.311 17.2094 28.311 17.3555V27.9805H6.52979V6.19922H17.1548C17.3009 6.19922 17.4204 6.07969 17.4204 5.93359V4.07422C17.4204 3.92812 17.3009 3.80859 17.1548 3.80859H5.20166C4.61396 3.80859 4.13916 4.2834 4.13916 4.87109V29.3086C4.13916 29.8963 4.61396 30.3711 5.20166 30.3711H29.6392C30.2269 30.3711 30.7017 29.8963 30.7017 29.3086V17.3555C30.7017 17.2094 30.5821 17.0898 30.436 17.0898Z"
      fill="white"
    />
    <path
      d="M12.2374 17.8502L12.1744 21.798C12.171 22.0936 12.4101 22.3359 12.7056 22.3359H12.7189L16.6369 22.2396C16.7033 22.2363 16.7697 22.2098 16.8161 22.1633L30.6253 8.38398C30.7283 8.28105 30.7283 8.11172 30.6253 8.00879L26.4982 3.88496C26.4451 3.83184 26.3786 3.80859 26.3089 3.80859C26.2392 3.80859 26.1728 3.83516 26.1197 3.88496L12.3138 17.6643C12.2658 17.7144 12.2386 17.7808 12.2374 17.8502ZM14.3458 18.6338L26.3089 6.69727L27.8097 8.19473L15.84 20.1379L14.3226 20.1744L14.3458 18.6338Z"
      fill="white"
    />
  </svg>
);

export const ApprovedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-7 h-7"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
  >
    <g stroke="white" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 13l4 4L19 7" />
      <rect x="2" y="2" width="20" height="20" rx="2" ry="2" />
    </g>
  </svg>
);

export const UsersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    fill="#ffffff"
    width="33"
    height="33"
  >
    <path d="M320 80C377.4 80 424 126.6 424 184C424 241.4 377.4 288 320 288C262.6 288 216 241.4 216 184C216 126.6 262.6 80 320 80zM96 152C135.8 152 168 184.2 168 224C168 263.8 135.8 296 96 296C56.2 296 24 263.8 24 224C24 184.2 56.2 152 96 152zM0 480C0 409.3 57.3 352 128 352C140.8 352 153.2 353.9 164.9 357.4C132 394.2 112 442.8 112 496L112 512C112 523.4 114.4 534.2 118.7 544L32 544C14.3 544 0 529.7 0 512L0 480zM521.3 544C525.6 534.2 528 523.4 528 512L528 496C528 442.8 508 394.2 475.1 357.4C486.8 353.9 499.2 352 512 352C582.7 352 640 409.3 640 480L640 512C640 529.7 625.7 544 608 544L521.3 544zM472 224C472 184.2 504.2 152 544 152C583.8 152 616 184.2 616 224C616 263.8 583.8 296 544 296C504.2 296 472 263.8 472 224zM160 496C160 407.6 231.6 336 320 336C408.4 336 480 407.6 480 496L480 512C480 529.7 465.7 544 448 544L192 544C174.3 544 160 529.7 160 512L160 496z" />
  </svg>
);

export const TotalClaimAppIcon = () => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 700 700"
    fill="#ffffff"
    stroke="#ffffff"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M525 641.666C540.471 641.666 555.308 635.521 566.248 624.581C577.187 613.641 583.333 598.804 583.333 583.333V233.333L408.333 58.333H175C159.529 58.333 144.692 64.4788 133.752 75.4184C122.812 86.3581 116.667 101.195 116.667 116.666V583.333C116.667 598.804 122.812 613.641 133.752 624.581C144.692 635.521 159.529 641.666 175 641.666H525ZM379.166 116.666L525 262.5H379.166V116.666ZM204.167 233.333H291.667V291.666H204.167V233.333ZM204.167 350H495.833V408.333H204.167V350ZM204.167 466.666H495.833V525H204.167V466.666Z"
    />
  </svg>
);

export const PendingClaimAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    fill="#ffffff"
    width="33"
    height="33"
  >
    <path d="M320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64zM296 184L296 320C296 328 300 335.5 306.7 340L402.7 404C413.7 411.4 428.6 408.4 436 397.3C443.4 386.2 440.4 371.4 429.3 364L344 307.2L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184z" />
  </svg>
);

export const ApprovedClaimAppIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    fill="#ffffff"
    width="33"
    height="33"
  >
    <path d="M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L308 576C285.3 544.5 272 505.8 272 464C272 363.4 349.4 280.8 448 272.7L448 234.6C448 217.6 441.3 201.3 429.3 189.3L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM608 464C608 384.5 543.5 320 464 320C384.5 320 320 384.5 320 464C320 543.5 384.5 608 464 608C543.5 608 608 543.5 608 464zM521.4 403.1C528.5 408.3 530.1 418.3 524.9 425.4L460.9 513.4C458.1 517.2 453.9 519.6 449.2 519.9C444.5 520.2 439.9 518.6 436.6 515.3L396.6 475.3C390.4 469.1 390.4 458.9 396.6 452.7C402.8 446.5 413 446.5 419.2 452.7L446 479.5L499 406.6C504.2 399.5 514.2 397.9 521.4 403.1z" />
  </svg>
);
